import React from "react";
import _ from "lodash";
import { Link } from "react-router-dom";

import IColumn from "models/IColumn";
import { columns as deliveriesColumns } from "../../deliveries/columns";
import { URLS } from "constants/urlConstants";

const renderDelivery = ({ ShipmentId, Shipment, RoleId }) =>
  ShipmentId ? (
    <Link
      className="link"
      to={`${URLS.DELIVERIES_URL}/${ShipmentId}?kooptype=${RoleId}`}
    >
      {Shipment.DeliveryId}
    </Link>
  ) : (
    "-"
  );

export const invoiceLinesColumns: IColumn[] = [
  {
    title: "QUANTITY",
    key: "Quantity",
    type: "number",
    visible: true
  },
  {
    title: "QUANTITY_UNIT",
    key: "QuantityUnit.Description",
    visible: true
  },
  {
    title: "ARTICLE_DESCRIPTION",
    key: "Description",
    visible: true,
    render: ({ Description, GrowerClaims }) => Description + GrowerClaims
  },
  {
    title: "SIZE",
    key: "Size.Description",
    visible: true
  },
  {
    title: "PRICE",
    key: "Price",
    type: "currency",
    visible: true
  },
  {
    title: "PRICE_UNIT",
    key: "PriceUnit.Description",
    visible: true
  },
  {
    title: "INVOICES_EX_BTW",
    key: "LineAmountExVat",
    type: "currency",
    visible: true
  },
  {
    title: "INVOICES_BTW",
    key: "VatPercentage",
    type: "percent",
    visible: true
  },
  {
    title: "INVOICES_DELIVERY",
    key: "Shipment.DeliveryId",
    render: renderDelivery,
    visible: true
  }
];

export const invoiceDeliveriesColumns = _.filter(
  deliveriesColumns,
  col => !_.includes(["checkbox"], col.key)
);
